const React = require('react');

const IntervalFilterConstructor = require('../IntervalFilterConstructor');

const Button = require('./components/IntervalBtn');
const SearchFilterReferral = require('./components/SearchFilterReferral');
const SelectFilterReferral = require('./components/SelectFilterReferral');

const IntervalFilter = (props) => (
  <IntervalFilterConstructor
    {...props}
    timeIntervalBtnComponent={Button}
    searchComponent={SearchFilterReferral}
    selectComponent={SelectFilterReferral}
  />
);

module.exports = IntervalFilter;
